var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1171(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171",
    transform: "translate(-142 -2424)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(142 2424)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "solution",
    transform: "translate(147.372 2432.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M47.9,3H38.4a.68.68,0,0,0-.679.679V6.4H36.358a1.358,1.358,0,0,0,0,2.716h1.358v3.4h2.716a2.716,2.716,0,1,1,5.432,0H47.9a.68.68,0,0,0,.679-.679V3.679A.68.68,0,0,0,47.9,3Z",
    transform: "translate(-8.34)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M25.428,59.716A3.4,3.4,0,0,0,28.754,57H22.1A3.4,3.4,0,0,0,25.428,59.716Z",
    transform: "translate(-4.2 -17.331)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M15.807,17.149a2.719,2.719,0,0,1,2.716,2.716h2.716V17.828a2.716,2.716,0,0,1,0-5.432V9h-.462A11.776,11.776,0,0,0,9.05,19.865h4.04A2.719,2.719,0,0,1,15.807,17.149Z",
    transform: "translate(-0.012 -1.926)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M16.474,39.3h4.753V33.865a2.716,2.716,0,1,1,0-5.432V25.716H17.153V24.358a1.358,1.358,0,1,0-2.716,0v1.358H9.014a11.712,11.712,0,0,0,4.3,8.64l3.156,2.582Z",
    transform: "translate(0 -6.419)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M34.507,24.358a1.358,1.358,0,1,0-2.716,0v1.358H27.716v4.074H26.358a1.358,1.358,0,1,0,0,2.716h1.358V39.3h3.4V36.938l3.156-2.582a11.715,11.715,0,0,0,4.3-8.64H34.507Z",
    transform: "translate(-5.131 -6.419)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M28.828,53H20.679a.679.679,0,1,0,0,1.358h8.149a.679.679,0,1,0,0-1.358Z",
    transform: "translate(-3.526 -16.047)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M29.544,49H18.679a.679.679,0,1,0,0,1.358H29.544a.679.679,0,0,0,0-1.358Z",
    transform: "translate(-2.884 -14.763)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1171);
export default __webpack_public_path__ + "static/media/Group 1171.843a86d283434494d9d5641933bb85b2.svg";
export { ForwardRef as ReactComponent };